// extracted by css-extract-rspack-plugin
export default {"bottomWrapper":"MailboxExchangeSynchronization_bottomWrapper__2ND4b","alert":"MailboxExchangeSynchronization_alert__Bazkx"};